// extracted by mini-css-extract-plugin
export default {"notice":"notice___VtzWSjQ"};